/**
 * @generated SignedSource<<03b7c710dd009f9e657ff475ecbf5d8d>>
 * @relayHash a5a0985597e3fe96f69600dbeadf25ab
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/568.0.0-2026-07-14T15:45:41.645Z/GetHelpZendeskModalCategoryRefetchQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskModalCategoryRefetchQuery$variables = {
  categoryId?: string | null;
  isSeller?: boolean | null;
  sellerId?: string | null;
};
export type GetHelpZendeskModalCategoryRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskModalCategory_viewer">;
  };
};
export type GetHelpZendeskModalCategoryRefetchQuery = {
  response: GetHelpZendeskModalCategoryRefetchQuery$data;
  variables: GetHelpZendeskModalCategoryRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "categoryId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isSeller"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sellerId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "isSeller",
  "variableName": "isSeller"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GetHelpZendeskModalCategoryRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GetHelpZendeskModalCategory_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "GetHelpZendeskModalCategoryRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              (v1/*:: as any*/),
              {
                "kind": "Variable",
                "name": "sellerId",
                "variableName": "sellerId"
              }
            ],
            "concreteType": "Contact1stdibsZendeskSupport",
            "kind": "LinkedField",
            "name": "zendeskSupport",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "categoryId",
                    "variableName": "categoryId"
                  }
                ],
                "concreteType": "ZendeskSupportCategorySections",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                  (v2/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      (v1/*:: as any*/)
                    ],
                    "concreteType": "ZendeskArticle",
                    "kind": "LinkedField",
                    "name": "articles",
                    "plural": true,
                    "selections": [
                      (v2/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      (v3/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/568.0.0-2026-07-14T15:45:41.645Z/GetHelpZendeskModalCategoryRefetchQuery",
    "metadata": {},
    "name": "GetHelpZendeskModalCategoryRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d97103bb111f2bf70605fa9fa5f97a13";

export default node;
